const IDS = {
    GRAPHIC_DESIGN: 'Graphic_Design',
    SEO_SERVICES: 'Seo_Services',
    SOCIAL_MEDIA_MARKETING: 'Social_Media_Marketing',
    SEARCH_ENGINE_MARKETING: 'Search_Engine_Marketing',
    ANIMATED_GIFS: 'Animated_Gifs',
    EBOOK_WRITING: 'Ebook_Writing',
    SPOKESPERSON: 'spokesperson',
    VISUAL_EFFECTS: 'Visual_Effects',
    LIVE_ACTION: 'Live_Action',
    WEBSITE_MATCH: 'Website_Match'
};

const GRAPHIC_DESIGN = {
    id: IDS.GRAPHIC_DESIGN,
    name: 'How fiverr works? - general',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/whuihiqnze1wmjjsjgmt'
};

const SEO_SERVICES = {
    id: IDS.SEO_SERVICES,
    name: 'How fiverr works? - SEO',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/zragbz6xe0vlwr2gx9ar'
};

const SOCIAL_MEDIA_MARKETING = {
    id: IDS.SOCIAL_MEDIA_MARKETING,
    name: 'How fiverr works? - social media marketing',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/nmf63gkldorokgneb0bf'
};

const SEARCH_ENGINE_MARKETING = {
    id: IDS.SEARCH_ENGINE_MARKETING,
    name: 'How fiverr works? - SEM',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/ybdp3tpggqr78tj0j2uu'
};

const ANIMATED_GIFS = {
    id: IDS.ANIMATED_GIFS,
    name: 'How fiverr works? - animated Gifs',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/wq8hdwv6wzrv4tikl97n'
};

const EBOOK_WRITING = {
    id: IDS.EBOOK_WRITING,
    name: 'How fiverr works? - Book & ebook writing',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/bpottdzwdnghjhylohro'
};

const SPOKESPERSON = {
    id: IDS.SPOKESPERSON,
    name: 'How fiverr works? - spokesperson video',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/hgmmt48vbittsf45nm2n'
};

const VISUAL_EFFECTS = {
    id: IDS.VISUAL_EFFECTS,
    name: 'How fiverr works? - visual effects',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/dzw1np8bfns5zqb7ygzp'
};

const LIVE_ACTION = {
    id: IDS.LIVE_ACTION,
    name: 'How fiverr works? - live action explainers',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/t4dpf50khzwjoo1c739m'
};

const WEBSITE_MATCH = {
    id: IDS.WEBSITE_MATCH,
    name: 'Website Match',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd_nl/dh7gbacmba9vyeamscxf'
};

module.exports = {
    IDS,
    GRAPHIC_DESIGN,
    SEO_SERVICES,
    SOCIAL_MEDIA_MARKETING,
    SEARCH_ENGINE_MARKETING,
    ANIMATED_GIFS,
    EBOOK_WRITING,
    SPOKESPERSON,
    VISUAL_EFFECTS,
    LIVE_ACTION,
    WEBSITE_MATCH
};
